"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("lodash");
var AnimationObject_1 = require("../AnimationObject");
var FontOrigin;
(function (FontOrigin) {
    FontOrigin[FontOrigin["System"] = 0] = "System";
    FontOrigin[FontOrigin["GoogleFonts"] = 1] = "GoogleFonts";
    FontOrigin[FontOrigin["ExternalCss"] = 2] = "ExternalCss";
    FontOrigin[FontOrigin["Url"] = 3] = "Url";
})(FontOrigin = exports.FontOrigin || (exports.FontOrigin = {}));
var AnimationFont = (function (_super) {
    tslib_1.__extends(AnimationFont, _super);
    function AnimationFont(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.clone = function () {
            return new AnimationFont(_.cloneDeep(_this._rawData), _this._rawDataVer);
        };
        return _this;
    }
    Object.defineProperty(AnimationFont.prototype, "uid", {
        get: function () {
            return this._rawData.uid;
        },
        set: function (uid) {
            this._rawData.uid = uid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationFont.prototype, "origin", {
        get: function () {
            return this._rawData.origin;
        },
        set: function (origin) {
            this._rawData.origin = origin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationFont.prototype, "path", {
        get: function () {
            return this._rawData.fPath;
        },
        set: function (path) {
            this._rawData.fPath = path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationFont.prototype, "fontClass", {
        get: function () {
            return this._rawData.fClass;
        },
        set: function (clazz) {
            this._rawData.fClass = clazz;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationFont.prototype, "family", {
        get: function () {
            return this._rawData.fFamily;
        },
        set: function (family) {
            this._rawData.fFamily = family;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationFont.prototype, "weight", {
        get: function () {
            return this._rawData.fWeight;
        },
        set: function (weight) {
            this._rawData.fWeight = weight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationFont.prototype, "style", {
        get: function () {
            return this._rawData.fStyle;
        },
        set: function (style) {
            this._rawData.fStyle = style;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationFont.prototype, "name", {
        get: function () {
            return this._rawData.fName;
        },
        set: function (name) {
            this._rawData.fName = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationFont.prototype, "ascent", {
        get: function () {
            return this._rawData.ascent;
        },
        set: function (ascent) {
            this._rawData.ascent = ascent;
        },
        enumerable: true,
        configurable: true
    });
    AnimationFont.prototype.toJSON = function () {
        return {
            uid: this.uid,
            origin: this.origin,
            path: this.path,
            fontClass: this.fontClass,
            family: this.family,
            weight: this.weight,
            style: this.style,
            name: this.name,
            ascent: this.ascent
        };
    };
    return AnimationFont;
}(AnimationObject_1.AnimationObject));
exports.AnimationFont = AnimationFont;
//# sourceMappingURL=AnimationFont.js.map